<template>
  <div class="banner-list">
    <div class="animated fadeIn pt-10">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.table.table') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn bg-main border-radius-4px right" @click="createTable"><i class="fa fa-plus"></i>&nbsp; {{$t('store.table.new')}}</button>
              </div>
            </div>
            <b-col cols="12" class="text-center">

              <b-row >
                <b-col cols="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="store.table">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
                <b-col cols="2">
                  <b-input-group v-bind:prepend="$t('store.table.active')">
                    <b-form-select v-model="filter.active" v-bind:value="filter.active" :options="statuses[$session.get('lang')]" v-bind:placeholder="$t('store.table.active')">
                    </b-form-select>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('store.table.active')}}</th>
                    <th scope="col">{{$t('store.table.sku')}}</th>
                    <th scope="col" :class="item.sort?'pointer':''" v-for="item in dataTable.fields" :key="item.id">
                      <span v-if="item.label != null">{{$t('store.table.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('store.table.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length == 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 3">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" @change="updateStatusItem(item)" />
                    </td>
                    <td>
                      <span> {{item.sku}}</span>
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id" >
                      <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                    <td scope="row" width="200">
                      <b-button v-if="item.active" size="sm" variant="primary" v-on:click="capture(item.sku)">
                        <i class="fa fa-qrcode"></i> {{$t('common.qr')}}
                      </b-button>
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.id)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!--    show QR code-->
              <b-modal ref="QR" id="qr_modal" hide-header hide-footer class="modal-dialog">
                <div class="qr-code-img" id="qr_image">
                  <qrcode-vue v-if="valueQR" :value="valueQR" size="450" level="H" id="qr_code"></qrcode-vue>
                  <div class="qr-code-text">
                    <span>{{qr_outletCode}} - {{qr_tableID}}</span>
                  </div>
                </div>
              </b-modal>
              <!--   END show QR code-->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage" v-model="dataTable.currentPage" />
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100, 200, 500]" class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }
  .custom-control-label::before {
    border-radius: 3px !important;
  }
  .qr-code-img {
    padding: 15px 15px 15px 15px;
  }
  .qr-code-text {
    padding-top: 20px;
  }
</style>
<script>
import SelectDropdown from '../../../components/Partials/SelectDropdown'
import DataTable from '../../../components/Partials/DataTable'
import DateRangePicker from 'vue2-daterange-picker'
import DatePicker from 'vue2-datepicker'
import cSwitch from '../../../components/Switch'
import axios from 'axios'
import html2canvas from 'html2canvas'
import QrcodeVue from 'qrcode.vue'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'TableList',
  components: {
    SelectDropdown,
    DateRangePicker,
    DatePicker,
    cSwitch,
    DataTable,
    QrcodeVue
  },
  data: function () {
    return {
      date: [],
      statuses: [],
      filter: {
        options: [],
        selected: null,
        active: '',
        name: '',
        sku: '',
        field: null,
        key: null,
      },
      outletCode: '',
      outletID: '',
      qr_outletCode: '',
      qr_tableID: '',
      valueQR: '',
      dataTable: {
        items: [],
        fields: [
          {
            name: 'name',
            label: 'name',
            filter: true,
            sort: false,
            render: (data, row) => {
              if (data == null) {
                return ''
              }
              return data[this.$session.get('lang')]
            }
          },
        ],
        sort: {
          field: 'name',
          type: 'desc'
        },
        currentPage: 1,
        total: 0,
        perPage: 20,
        source: null
      },
      item: {}
    }
  },
  methods: {
    /**
     * update active by uuid
     * @param uuid and active
     */
    updateStatusItem (item) {
      this.axios.outlet.updateTable(item, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
      }, function (response) {
        vm.refreshData()
      })
    },
    getStoreInfo (uuid) {
      const vm = this
      vm.axios.outlet.getOutletDetail(uuid, response => {
        if (response.status === 200) {
          let data = response.data.data.item
          vm.outletCode = data.code
          vm.outletID = data.id
          vm.refreshData()
        }
      }, error => {
        console.log('error', error)
      })
    },
    /**
     * update sort field and sort type then refresh data
     * @param field
     */
    updateSort (field) {
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].name == field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort == false)) {
          return
        }
      }
      if (this.dataTable.sort.field != field) {
        this.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      } else {
        if (this.dataTable.sort.type == 'asc') {
          this.dataTable.sort = {
            field: field,
            type: 'desc'
          }
        } else {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }

      this.refreshData()
    },
    /**
     * refresh data for data table
     */
    refreshData () {
      if (cancel != null) {
        cancel()
      }
      let vm = this

      // get params
      let _data = {
        outlet_id: vm.outletID,
        page: this.dataTable.currentPage,
        limit: this.dataTable.perPage
      }
      if (String(this.filter.active) != '') {
        _data['active'] = this.filter.active
      }

      if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
        _data[this.filter.field] = this.filter.key.trim()
      }

      // process to send via get method
      let params = ''
      for (let key in _data) {
        params += key+'='+_data[key]+'&'
      }
      // remove tail
      params = params.slice(0, -1)

      console.log("asdasgdfasgda", params)

      vm.axios.outlet.getTableList(params, 
      function (response) {
        vm.dataTable.items = response.data.data.items
        vm.dataTable.total = response.data.data.pagination.total
        this.$forceUpdate()
      })
      
    },
    /**
     * move to detail page by uuid
     * @param uuid
     */
    editItem (id) {
      this.$router.push({name: 'table-create', params: { uuid: this.$route.params.uuid, action: id }})
    },
    capture(tableID) {
      let vm = this
      vm.qr_outletCode = vm.outletCode
      vm.qr_tableID = tableID
      let prefixUrl = vm.$store.getters.config.manual_config.prefix_url ? vm.$store.getters.config.manual_config.prefix_url : ''
      let baseSiteUrl = vm.$store.getters.config.main.base_site_url + prefixUrl + '?store_code=' + vm.qr_outletCode + '&table_id='+tableID
      vm.valueQR = baseSiteUrl
      vm.$refs.QR.show()
      setTimeout(() => {
        vm.printCanvas()
      }, 500);
      
    },
    printCanvas: function () {
      let vm = this

      html2canvas(document.getElementById('qr_image'), {
        scrollX: 0,
        scrollY: 0
      }).then(function (canvas) {
        var imageData = canvas.toDataURL('image/png')
        var element = document.createElement('a')
        element.setAttribute('href', imageData)
        element.setAttribute('download', 'QR_table_' + vm.qr_tableID +'_store_' + vm.qr_outletCode)
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        document.body.removeChild(element)
      })
      vm.$refs.QR.hide()
    },
    createTable () {
      this.$router.push({name: 'table-create', params: { uuid: this.$route.params.uuid, action: 'create' }})
    }
  },
  mounted() {
    if (this.$route.params.uuid) {
      this.getStoreInfo(this.$route.params.uuid)
    }
  },
  created: function () {
    vm = this
    let CancelToken = vm.axios.CancelToken
    vm.dataTable.source = CancelToken.source()

    for (let i in vm.dataTable.fields) {
      let field = vm.dataTable.fields[i].name
      if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter == true) {
        vm.filter.options.push(vm.dataTable.fields[i])
      }
      if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort == true && vm.dataTable.sort.field == null) {
        vm.dataTable.sort = {
          field: field,
          type: 'asc'
        }
      }
    }
    let langs = vm.$store.getters.languages
    for (let l in langs) {
      vm.statuses[langs[l]] = [
        {text: vm.$t('common.all', langs[l]), value: ''},
        {text: vm.$t('common.active', langs[l]), value: '1'},
        {text: vm.$t('common.inactive', langs[l]), value: '0'}
      ]
    }

    vm.$Progress.start()
    let filter = this.$session.get('filter', null)
    if (filter != null && this.$route.query && this.$route.query.rollback) {
      for (let i in filter.filter) {
        this.filter[i] = filter.filter[i]
      }
      for (let i in filter.dataTable) {
        this.dataTable[i] = filter.dataTable[i]
      }
    }
    vm.refreshData()
  },
  beforeDestroy: function () {
    this.$session.set('filter', {
      filter: this.filter,
      dataTable: {
        sort: {
          field: this.dataTable.sort.field,
          type: this.dataTable.sort.type
        },
        currentPage: this.dataTable.currentPage,
        perPage: this.dataTable.perPage
      }
    })
  },
  watch: {
    'dataTable.currentPage': function (val) {
      vm.refreshData()
    },
    'dataTable.perPage': function (val) {
      vm.refreshData()
    },
    'filter.active': function (val) {
      vm.refreshData()
    }
  },
  computed : {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/outlets/TableList.vue